// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"376":"b2af6249","487":"87e530d3","541":"bc61b851","760":"55074e20","815":"ef2d7f23"}[chunkId] + ".css";
};